import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal } from "@/components/Kinetic";
import { api } from "@/lib/api";
import { formatShowDate } from "@/pages/Tour";

export default function TourTeaser() {
  const [shows, setShows] = useState([]);

  useEffect(() => {
    api.get("/shows").then((r) => setShows(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (shows.length === 0) return null;

  return (
    <section data-testid="home-tour-section" className="mx-auto max-w-7xl px-6 py-32">
      <Reveal>
        <div className="mb-16 flex items-end justify-between">
          <div>
            <p className="mb-3 font-mono text-xs tracking-[0.4em] text-primary">ON THE ROAD — 2026</p>
            <h2 className="font-anton text-5xl text-white md:text-7xl">TOUR DATES</h2>
          </div>
          <Link
            to="/tour"
            data-testid="home-tour-viewall"
            className="hidden items-center gap-2 font-mono text-xs tracking-[0.25em] text-white/60 transition-colors duration-300 hover:text-primary md:flex"
          >
            ALL DATES <ArrowUpRight size={14} />
          </Link>
        </div>
      </Reveal>

      <div>
        {shows.map((s, i) => {
          const d = formatShowDate(s.date);
          return (
            <Reveal key={s.id} delay={i * 0.08}>
              <Link
                to="/tour"
                data-testid={`home-tour-show-${s.id}`}
                className="group flex items-center gap-6 border-b border-white/10 py-6 transition-colors duration-300 hover:bg-white/[0.03]"
              >
                <span className="w-16 shrink-0 font-mono text-sm text-primary">
                  {d.month} {d.day}
                </span>
                <span className="flex-1 font-anton text-2xl text-white transition-colors duration-300 group-hover:text-primary md:text-3xl">
                  {s.city}
                </span>
                <span className="hidden items-center gap-2 font-mono text-xs tracking-[0.2em] text-white/40 md:flex">
                  <MapPin size={12} /> {s.venue}
                </span>
                <span className={`px-3 py-1 font-mono text-[10px] tracking-[0.25em] ${
                  s.status === "SOLD OUT" ? "border border-white/25 text-white/50" : "bg-primary/15 text-primary"
                }`}>
                  {s.status}
                </span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
